import { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import * as apiUtility from "../../config/APIUtils";
import { IconButton, Paper, Tooltip, Box, Typography, Button } from '@mui/material';
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from 'react-icons/ri';

function OrganizationMissingTemplate(props) {
    const [showSpinner, setshowSpinner] = useState(false);
    const [orgStaffTemplateData, setOrgStaffTemplateSumm] = useState([]);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    var orgId = props.org_id;
    var filterObj = props.filterBy;
    var homeFlag = props.homeFlag;
    var staffFlag = props.staffFlag;
    var roleId = props.roleId;
    var crsPolicyType = props.crsPolicyType
    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            setshowSpinner(true);
            try {
                const body = {
                    org: orgId,
                    firstName: filterObj?.firstName || "",
                    lastName: filterObj?.lastName || "",
                    homeFlag: homeFlag,
                    staffFlag: staffFlag,
                    roleId: roleId || 0,
                    crsPolicyType:crsPolicyType
                };
                const apiRequest = apiUtility.apiInputRequest;
                apiRequest.endPoint = "audit-report/org-missing-courses";
                apiRequest.data = body;
                const res = await apiUtility.sendAPIDataPOST(apiRequest);
                if (!mounted) return;
                setOrgStaffTemplateSumm(Array.isArray(res.data) ? res.data : []);
            } catch (error) {
                console.error("Error fetching org-missing-courses:", error);
                if (mounted) {
                    setDataForErrorPopup("No data available. Please try again.");
                    setShowErrorPopup(true);
                    setOrgStaffTemplateSumm([]);
                }
            } finally {
                if (mounted) setshowSpinner(false);
            }
        };
        if (orgId !== undefined && orgId !== null) fetchData();
        return () => {
            mounted = false;
        };
    }, [orgId, filterObj, homeFlag, staffFlag, roleId])

    var orgStaffTemplateCols = [{
        dataField: 'user_id',
        sort: true,
        text: 'User ID'
    },
    {
        dataField: 'first_name',
        sort: true,
        text: 'First Name'
    }, {
        dataField: 'last_name',
        sort: true,
        text: 'Last Name'
    }, {
        dataField: 'role_id',
        sort: true,
        text: 'Role ID'
    },
    {
        dataField: 'role_name',
        sort: true,
        text: 'Role Name'
    },
    {
        dataField: 'role_status',
        sort: true,
        text: 'Role Status'
    },
    {
        dataField: 'home_name',
        sort: true,
        text: 'Home'
    },
    {
        dataField: 'home_status',
        sort: true,
        text: 'Home Status'
    },
        {
        dataField: 'type',
        sort: true,
        text: 'Course/Home Doc'
    }
        , {
        dataField: 'missing_courses',
        text: 'Incomplete Course IDs/Home Doc Codes'
    }

    ];

    //  if (props.crsPolicyType=='11') {
    //     orgStaffTemplateCols.push({
    //     dataField: 'missing_policies',
    //     sort: true,
    //     text: 'Incomplete Policy IDs'
    // });
    // }
    // if (props.crsPolicyType=='10') {
    //     orgStaffTemplateCols.splice(8, 1);
    //     orgStaffTemplateCols.push({
    //     dataField: 'missing_policies',
    //     sort: true,
    //     text: 'Incomplete Policy IDs'
    // });
    // }


    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{ A: 'CarePassport - Deficiency Report for Organization ID : ' + String(orgId) }];
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null)?sessionStorage.getItem('userType').toUpperCase():"User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            var reportHeaders;
            // if(crsPolicyType=='9'){
            //     reportHeaders = { A: 'User ID', B: 'First Name', C: 'Last Name', D: 'Role ID', E: 'Role Name', F: 'Role Status', G: 'Home', H: 'Home Status', I: 'Missing Courses' };
            // reportView.push(reportHeaders);
            // // orgStaffTemplateData.forEach(element => {
            // orgStaffTemplateData.forEach(element => {
            //     rowsCount += 1;
            //     var tempObj = {
            //         A: element.user_id,
            //         B: element.first_name,
            //         C: element.last_name,
            //         D: element.role_id,
            //         E: element.role_name,
            //         F: element.role_status,
            //         G: element.home_name,
            //         H: element.home_status,
            //         I: element.missing_courses
            //     };
            //     reportView.push(tempObj);
            // });
            // }
            // else if(crsPolicyType=='10'){
            // reportHeaders = { A: 'User ID', B: 'First Name', C: 'Last Name', D: 'Role ID', E: 'Role Name', F: 'Role Status', G: 'Home', H: 'Home Status', I: 'Missing Policies' };
            // reportView.push(reportHeaders);
            // // orgStaffTemplateData.forEach(element => {
            // orgStaffTemplateData.forEach(element => {
            //     rowsCount += 1;
            //     var tempObj = {
            //         A: element.user_id,
            //         B: element.first_name,
            //         C: element.last_name,
            //         D: element.role_id,
            //         E: element.role_name,
            //         F: element.role_status,
            //         G: element.home_name,
            //         H: element.home_status,
            //         I: element.missing_policies
            //     };
            //     reportView.push(tempObj);
            // });
            // }
            // else{
            
            reportHeaders = { A: 'User ID', B: 'First Name', C: 'Last Name', D: 'Role ID', E: 'Role Name', F: 'Role Status', G: 'Home', H: 'Home Status', I: 'Course/Home Doc', J: 'Missing Courses/Home Docs' };
            reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            orgStaffTemplateData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.user_id,
                    B: element.first_name,
                    C: element.last_name,
                    D: element.role_id,
                    E: element.role_name,
                    F: element.role_status,
                    G: element.home_name,
                    H: element.home_status,
                    I: element.type,
                    J: element.missing_courses
                };
                reportView.push(tempObj);
            });
            
            //}
            
            //});
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Deficiency Report");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "User ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: crsPolicyType=='11'? "A1:J1":"A1:I1",
                tbodyRange: `A7:I${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:I${headerIndexes[0] + 1}`
                        : null,
                theadRange1:
                    headerIndexes?.length >= 2
                        ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                        : null,
                tFirstColumnRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                        : null,
                tLastColumnRange:
                    headerIndexes?.length >= 1
                        ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                        : null,

                tFirstColumnRange1:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                        : null,
                tLastColumnRange1:
                    headerIndexes?.length >= 1
                        ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                        : null,
            };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(30);
                    sheet.column("D").width(20);
                    sheet.column("E").width(40);
                    sheet.column("F").width(15);
                    sheet.column("G").width(40);
                    sheet.column("H").width(15);
                    sheet.column("I").width(50);
                    if(crsPolicyType=='11'){
                    sheet.column("J").width(50);
                    }
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                            horizontalAlignment: "left",
                        });
                    }
                    sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                            bold: true,
                        });
                    }

                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    var dateVar = new Date();
                    var fileName = "Carepassport_DeficiencyReport-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                    // setDataForSuccessPopup("Downloaded Successfully");
                    // setShowSuccessPopup(true);
                });
            });
        } catch (error) {
            setDataForErrorPopup("Something went wrong while processing excel!");
            setShowErrorPopup(true);
        }
    }

    return (
        <div>
            {showSpinner && (
                <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, background: "rgba(255,255,255,0.5)" }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </div>
            )}
            <Paper sx={{ p: 1, borderRadius: "1.5px" }}>
                {(!showSpinner && orgStaffTemplateData.length === 0) ? (
                    <Box sx={{ p: 6, textAlign: "center" }}>
                        <Typography variant="h6" gutterBottom>No data available</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            There are no deficiency records for the selected organization / filters.
                        </Typography>
                        <Button variant="outlined" onClick={() => {
                            // simple manual retry: refetch by toggling spinner and relying on useEffect deps
                            setshowSpinner(true);
                            setTimeout(() => setshowSpinner(false), 300);
                        }}>Retry</Button>
                    </Box>
                ) : (
                    <BootstrapTable id='organizationStaffTemplateTable' keyField='id' data={orgStaffTemplateData} columns={orgStaffTemplateCols} striped hover />
                )}
                <Row>
                    <Col xs={0} md={8}>

                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <Paper component="form" variant="outlined"
                            sx={{ float: "right", display: 'flex', marginBottom: "4px", alignItems: 'center', width: 50 }}
                        >
                            <Tooltip variant="contained" title="Export to Excel" disableRipple>
                                <IconButton color="primary" onClick={exportInExcel} sx={{ p: '10px' }} aria-label="directions">
                                    <RiFileExcel2Line />
                                </IconButton>
                            </Tooltip>
                        </Paper>
                    </Col>
                </Row>
            </Paper>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </div>

    )
}

export default OrganizationMissingTemplate